<template>
	<div class="home">
		<div class="container">
			<div class="boxes">
				<div class="box accent">
					<span class="bigNumber">{{courseStatus.len}}</span>
					cursos
					<hr>
					<div class="details">
						<strong>{{pad2(courseStatus.soon)}}</strong> - Em breve
					</div>
					<div class="details">
						<strong>{{pad2(courseStatus.open)}}</strong> - Aberto(s)
					</div>
					<div class="details">
						<strong>{{pad2(courseStatus.closed)}}</strong> - Encerrado(s) / Inativo(s)
					</div>
				</div>
				<div class="box">
					<span class="bigNumber">{{contactStatus.len}}</span>
					contatos
					<hr>
					<div class="details">
						<strong>{{pad2(contactStatus.last30)}}</strong> - Últimos 30 dias
					</div>
					<div class="details">
						<strong>{{pad2(contactStatus.last90)}}</strong> - Últimos 90 dias
					</div>
				</div>
				<div class="box">
					<span class="bigNumber">{{newsStatus.len}}</span>
					newsletter
					<hr>
					<div class="details">
						<strong>{{pad2(newsStatus.last30)}}</strong> - Últimos 30 dias
					</div>
					<div class="details">
						<strong>{{pad2(newsStatus.last90)}}</strong> - Últimos 90 dias
					</div>
				</div>
				<div class="box">
					<span class="bigNumber">{{commentStatus.len}}</span>
					comentários
					<hr>
					<div class="details">
						<strong>{{pad2(commentStatus.pending)}}</strong> - pendentes
					</div>
					<div class="details">
						<strong>{{pad2(commentStatus.notPending)}}</strong> - aprovados
					</div>
				</div>
			</div>

			<fluke-card v-if="showUpdates">
				<header>
					<div class="title">
						Últimas atualizações
					</div>
					<div class="description">
						Lista de cadastro e alterações mais recentes
					</div>
				</header>
				<main>
					<div v-if="permissions.contacts.read">
						<strong>Contatos</strong>
						<table>
							<thead>
								<tr>
									<th>Nome</th>
									<th>Email</th>
									<th class="t-right">Data</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in leadContacts" :key="index">
									<td>{{item.name}}</td>
									<td>{{item.email}}</td>
									<td class="t-right">{{item.createdAt}}</td>
								</tr>
							</tbody>
						</table>
						<br>
						<br>
					</div>
					<div v-if="permissions.newsletter.read">
						<strong>Newsletter</strong>
						<table>
							<thead>
								<tr>
									<th>Email</th>
									<th class="t-right">Data</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in leadNews" :key="index">
									<td>{{item.email}}</td>
									<td class="t-right">{{item.createdAt}}</td>
								</tr>
							</tbody>
						</table>
						<br>
						<br>
					</div>
					<div v-if="permissions.blog.read">
						<strong>Comentários pendentes</strong>
						<table>
							<thead>
								<tr>
									<th>Nome</th>
									<th>Email</th>
									<th class="t-right">Data</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in leadComments" :key="index">
									<td>{{item.name}}</td>
									<td>{{item.email}}</td>
									<td class="t-right">{{item.createdAt}}</td>
								</tr>
							</tbody>
						</table>
					</div>

				</main>
			</fluke-card>

			<fluke-card>
				<header>
					<div class="title">
						Funções úteis
					</div>
					<div class="description">
						Ferramentas e configurações de utilidade geral para o site
					</div>
				</header>
				<main>
					<button @click="sitemap" class="fluke-btn">Gerar site map</button>
					&nbsp;&nbsp;
					<!-- <button class="fluke-btn fluke-grey">Limpar imagens</button> -->
				</main>
			</fluke-card>

			<global-popup ref='sitemap' title='Sitemap' confirm="Ok">
				<pre>{{sitemapstring}}</pre>
			</global-popup>
		</div>

	</div>
</template>

<script>
import ImagePicker from './../components/Main/Content/ImageGallery/ImageGallery';
import axios from 'axios';
import Card from './../components/Main/Content/Card/Card';
import Button from './../components/Main/Content/Button/Button.vue';

import permission from '../mixins/permissions';


export default {
	mixins: [ permission ],
	components: {
		ImagePicker,
		'fluke-card': Card,
		'fluke-button': Button
	},
	data: function() {
		return {
			dialog: false,
			image: '',
			sitemapstring: '',
			courseStatus: {
				len: 0,
				closed: 0,
				soon: 0,
				open: 0
			},
			contactStatus: {
				len: 0,
				last30: 0,
				last90: 0
			},
			newsStatus: {
				len: 0,
				last30: 0,
				last90: 0
			},
			commentStatus: {
				len: 0,
				pending: 0,
				notPending: 0
			},
			leadContacts: [],
			leadNews: [],
			leadComments: [],
			permissions: {
				contacts: { read: false, write: false },
				newsletter: { read: false, write: false },
				blog: { read: false, write: false }
			},
			showUpdates: false
		}
	},
	created: function() {
		this.permissions.contacts = this.getUserPagePermission('contacts');
		this.permissions.newsletter = this.getUserPagePermission('newsletter');
		this.permissions.blog = this.getUserPagePermission('blog');

		if(
			this.permissions.contacts.read ||
			this.permissions.newsletter.read ||
			this.permissions.blog.read
		){
			this.showUpdates = true;
		}

		axios.get(
			this.$myServerAddresses.courses + 'courses',
            {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            }
		)
		.then( result => {
			this.courseStatus.len = result.data.length;

			result.data.forEach( element => {
				var dates = JSON.parse(element.dates);
                dates = dates ? dates : []
				if( element.closed || !element.publish ) {
					this.courseStatus.closed++;
				} else if( !dates.length && element.publish ) {
					this.courseStatus.soon++;
				} else if(
					element.publish &&
					dates.length
				) {
					this.courseStatus.open++;
				}
			});
		});

		axios.get(
			this.$myServerAddresses.contact + 'contact', {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            }
		)
		.then( result => {
			this.contactStatus.len = result.data.length;

			var now = new Date();
			result.data.forEach(element => {
				var dateArr = element.createdAt.split(/\D+/);
				var contDate = new Date(Date.UTC(dateArr[0],dateArr[1]-1,dateArr[2],dateArr[3],dateArr[4],dateArr[5],0));
				var diff = Math.floor( (Math.abs(now - contDate)/1000)/86400 );
				if( diff <  30 ) {
					this.contactStatus.last30++;
				}
				if( diff < 90 ) {
					this.contactStatus.last90++;
				}
			});

			this.leadContacts = result.data.sort(this.dateCompare).slice(0,5).map( elem => {
				var newData = elem.createdAt.slice(0,-8).split('T');
				elem.createdAt = newData[0].split('-').reverse().join('/') + ' ' + newData[1];
				return elem;
			});
		});

		axios.get(
			this.$myServerAddresses.newsletter + 'news', {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            }
		)
		.then( result => {
			this.newsStatus.len = result.data.length;

			var now = new Date();
			result.data.forEach(element => {
				var dateArr = element.createdAt.split(/\D+/);
				var contDate = new Date(Date.UTC(dateArr[0],dateArr[1]-1,dateArr[2],dateArr[3],dateArr[4],dateArr[5],0));
				var diff = Math.floor( (Math.abs(now - contDate)/1000)/86400 );
				if( diff <  30 ) {
					this.newsStatus.last30++;
				}
				if( diff < 90 ) {
					this.newsStatus.last90++;
				}
			});

			this.leadNews = result.data.sort(this.dateCompare).slice(0,5).map( elem => {
				var newData = elem.createdAt.slice(0,-8).split('T');
				elem.createdAt = newData[0].split('-').reverse().join('/') + ' ' + newData[1];
				return elem;
			});
		});

		axios
			.get( this.$myServerAddresses.blog + 'comments/peding', {
                headers: {
                    'X-Fluke': this.$cookies.get('token'),
                }
            })
			.then( result => {
                const isValid = Array.isArray(result.data)
                if (isValid) {
                    this.commentStatus.pending = result.data.length;
                    this.leadComments = result.data.sort(this.dateCompare2).slice(0,5).map( elem => {
                        var newData = elem.created_at.slice(0,-8).split('T');
                        elem.createdAt = newData[0].split('-').reverse().join('/') + ' ' + newData[1];
                        return elem;
                    });

                    axios
                        .get( this.$myServerAddresses.blog + 'comments/notpeding', {
                            headers: {
                                'X-Fluke': this.$cookies.get('token'),
                            }
                        })
                        .then( resultInner => {
                            this.commentStatus.notPending = resultInner.data.length;
                            this.commentStatus.len = this.commentStatus.pending + this.commentStatus.notPending;
                        });
                }
			});
	},
	methods: {
		dateCompare: function(date1, date2)
        {
            var d1 = date1.createdAt;
            var d2 = date2.createdAt;
            var comparison = 0;

            if( d1 < d2 ) comparison = 1;
            else if( d1 > d2 )comparison = -1;

            return comparison;
        },
		dateCompare2: function(date1, date2)
        {
            var d1 = date1.created_at;
            var d2 = date2.created_at;
            var comparison = 0;

            if( d1 < d2 ) comparison = 1;
            else if( d1 > d2 )comparison = -1;

            return comparison;
        },
		pad2: function(number)
		{
			return (number < 10 ? '0' : '') + number;
		},
		cc: function()
		{
			this.dialog=true;
			this.$store.state.dialog.open=true;
		},
		sitemap: function()
		{
			axios
				.get(this.$myServerAddresses.admin)
				.then( result => {
					var URLs = result.data;
					this.sitemapstring = '<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';

					URLs.forEach(url => {
						this.sitemapstring += '\t<url>\n';
						this.sitemapstring += '\t\t<loc>' + this.$myServerAddresses.site + url + '</loc>\n';
						this.sitemapstring += '\t</url>\n';
					});

					this.sitemapstring += '</urlset>';

					this.$refs.sitemap.alert();
				})
		}
	}
}
</script>

<style lang="scss">
.fluke-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background-color: rgba( 0, 0 ,0 ,0.5 );
	display: none;
	z-index: 200;

	&.active
	{
		display: block;
	}
}
.boxes
{
	display: flex;
	justify-content: space-between;

	.box
	{
		box-sizing: border-box;
		padding: 10px 20px 0 20px;
		height: auto;
		border-radius: 3px;
		background-color: #e0e0e0;
		height: 150px;
		width: 23%;
		box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.25);
		justify-content: center;
		align-items: center;

		@media(max-width: 1466px) { height: 180px; }

		.bigNumber
		{
			display: inline-block;
			margin-right: 10px;
			font-size: 45px;
			font-weight: 900;
		}

		.details
		{
			padding: 4px 0;
		}

		hr
		{
			height: 1px;
			border: none;
			background-color: #d2cfcf;
			margin: 10px 0 12px 0;
		}

		&.accent
		{
			background-color: #FEC402;

			.details
			{
				padding: 0;
			}

			hr
			{
				background-color: #e8b300
			}
		}
	}
}
</style>
